import React from 'react';
import {Layout, Typography, Button} from 'antd';
import {useNavigate} from 'react-router-dom';
import Header from "../../../components/molecules/Header/component";
import {useIsMobile} from '../../../utils/helpers';
import Footer from "../../../components/molecules/Footer/component";

const {Content} = Layout;
const {Title, Paragraph} = Typography;

const CancellationsPage: React.FC = () => {
    const navigate = useNavigate();
    const isMobile = useIsMobile();

    return (
        <div>
            <Header/>
            <Content style={{maxWidth: 900, margin: '0 auto', padding: '32px 16px 48px'}}>
                <article>
                    <header>
                        <Title level={2}>Cancellation policy</Title>
                        <Paragraph>
                            You may cancel your subscription at any time from the dashboard. Cancelling prevents future
                            billing but does not automatically refund amounts already paid for the current billing
                            period
                            (except where stated in our <a href="/refunds">Refunds</a> policy).
                        </Paragraph>
                    </header>

                    <section style={{marginTop: 20}}>
                        <Title level={3}>How to cancel</Title>
                        <Paragraph>
                            Go to <strong>Settings → Manage billing → Cancel subscription</strong> in your account.
                            Alternatively you can contact support at <a
                            href="mailto:info@promotifyai.com">info@promotifyai.com</a> and request
                            cancellation from our team.
                        </Paragraph>
                    </section>

                    <section style={{marginTop: 20}}>
                        <Title level={3}>When cancellation takes effect</Title>
                        <Paragraph>
                            Cancelling stops automatic renewals. Your subscription remains active until the end of the
                            current billing period (for example, the paid month or the paid yearly period). Access to
                            paid features continues until that date.
                        </Paragraph>
                    </section>

                    <section style={{marginTop: 20}}>
                        <Title level={3}>Impact on campaigns and balances</Title>
                        <Paragraph>
                            Cancelling a subscription does not remove funds already allocated to running campaigns.
                            Advertiser campaign budgets and pending click validations continue to be processed.
                            Promoters
                            and partners retain earned balances but payouts are processed according to our normal payout
                            schedule and verification rules.
                        </Paragraph>
                    </section>

                    <section style={{marginTop: 20}}>
                        <Title level={3}>Reactivating your subscription</Title>
                        <Paragraph>
                            You can reactivate your subscription at any time by choosing a plan in the Plans section.
                            When you reactivate, billing restarts immediately according to the selected billing
                            interval.
                        </Paragraph>
                    </section>

                    <section style={{marginTop: 20}}>
                        <Title level={3}>Trial users</Title>
                        <Paragraph>
                            New accounts receive a one-month free trial. If you cancel during the trial you will not be
                            charged. If you do not cancel before the trial ends, your chosen plan is charged immediately
                            at the end of the trial.
                        </Paragraph>
                    </section>

                    <section style={{marginTop: 20}}>
                        <Title level={3}>Need help?</Title>
                        <Paragraph>
                            If you have questions about cancellation, refunds, or need assistance, contact support
                            at{' '}
                            <a href="mailto:info@promotifyai.com">info@promotifyai.com</a>. We typically respond within
                            1 business day.
                        </Paragraph>
                    </section>

                    <footer
                        style={{
                            marginTop: 28,
                            display: 'flex',
                            gap: 8,
                            flexDirection: isMobile ? 'column' : 'row',
                            justifyContent: isMobile ? 'stretch' : 'flex-end'
                        }}
                    >
                        <Button
                            type="default"
                            onClick={() => navigate('/contact')}
                            block={isMobile}
                            style={{width: isMobile ? '100%' : 'auto'}}
                        >
                            Contact support
                        </Button>
                    </footer>
                </article>
            </Content>
            <Footer/>
        </div>
    );
};

export default CancellationsPage;